/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Error.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-300.js"
import * as fromFlow from 'Logic/ViewsFlow.js'
import ButtonBlue from 'DesignSystem/ButtonBlue/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  alignItems: "center",
backgroundColor: "rgba(225,88,41, 0.80)",
flexBasis: "auto",
flexGrow: 1,
flexShrink: 1,
justifyContent: "center"})
styles.Vertical1 = css({label: 'Vertical1',
  alignItems: "center",
alignSelf: "center",
backgroundColor: "#ffffff",
borderBottomLeftRadius: 15,
borderBottomRightRadius: 15,
borderTopLeftRadius: 15,
borderTopRightRadius: 15,
marginBottom: 15,
marginLeft: 15,
marginRight: 15,
maxWidth: 440,
paddingBottom: 50,
paddingLeft: 50,
paddingRight: 50,
paddingTop: 50,
boxShadow: "0px 10px 30px 0px rgba(237,55,26, 0.83)"})
styles.Text = css({label: 'Text',
  color: "#e15829",
fontFamily: "WonderUnitSans",
fontWeight: 300,
textAlign: "center"})
styles.Text1 = css({label: 'Text1',
  fontFamily: "WonderUnitSans",
fontWeight: 300,
hyphens: "none",
marginTop: 20,
textAlign: "center"})
styles.Text2 = css({label: 'Text2',
  fontFamily: "WonderUnitSans",
fontWeight: 300,
hyphens: "none",
marginTop: 10,
textAlign: "center"})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 30,
alignSelf: "center"})

export default function Error({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  signOut,
viewPath= "/App/RuntimeError/Error"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<div
 data-testid="Error.Vertical"
 data-view-path="/App/RuntimeError/Error"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="Error.Vertical:1"
 data-view-path="/App/RuntimeError/Error"
 className={`views-block ${styles.Vertical1}`}
>
<span
 data-testid="Error.Text"
 data-view-path="/App/RuntimeError/Error"
 className={`views-text ${styles.Text}`}
>
Something went wrong
</span>
<span
 data-testid="Error.Text:1"
 data-view-path="/App/RuntimeError/Error"
 className={`views-text ${styles.Text1}`}
>
We apologize for the inconvenience.
</span>
<span
 data-testid="Error.Text:2"
 data-view-path="/App/RuntimeError/Error"
 className={`views-text ${styles.Text2}`}
>
Report this problem to help us solve it faster.
</span>
<div
 data-testid="Error.Horizontal"
 data-view-path="/App/RuntimeError/Error"
 className={`views-block ${styles.Horizontal}`}
>
<ButtonBlue
 data-testid="Error.ButtonBlue"
 data-view-path="/App/RuntimeError/Error"
viewPath={`${viewPath}/ButtonBlue`}
 width={130}
 marginRight={8}
 text="Report this problem"
 onClick={() => setFlowTo("/App/RuntimeError/GetHelp")}
 isSelected={flow.has("/App/RuntimeError/GetHelp")}
/>
<ButtonBlue
 data-testid="Error.ButtonBlue:1"
 data-view-path="/App/RuntimeError/Error"
viewPath={`${viewPath}/ButtonBlue`}
 width={130}
 text="Sign out"
 onClick={signOut}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}